{
  "version": 1,
  "asset_id": "64274037-f3b4-4095-81c8-e28863c6de4e",
  "project_id": "7d1776ab-cb36-43c5-a7cd-acaad4e00de7",
  "url": "/__l5e/assets-v1/64274037-f3b4-4095-81c8-e28863c6de4e/OP2P-CRM-e-Agentes-de-IA-integracao-google-forms-e-sheets.webp",
  "r2_key": "a/v1/7d1776ab-cb36-43c5-a7cd-acaad4e00de7/64274037-f3b4-4095-81c8-e28863c6de4e/OP2P-CRM-e-Agentes-de-IA-integracao-google-forms-e-sheets.webp",
  "original_filename": "OP2P-CRM-e-Agentes-de-IA-integracao-google-forms-e-sheets.webp",
  "size": 2282,
  "content_type": "image/webp",
  "created_at": "2026-09-26T11:24:40Z"
}
